<template>
  <el-tabs>
    <el-tab-pane label="成员列表">
      <el-table :data="memberList">
        <el-table-column prop="StoreId" label="店铺ID"></el-table-column>
        <el-table-column prop="Contacts" label="姓名"></el-table-column>
        <el-table-column prop="Mobile" label="手机号"></el-table-column>
      </el-table>
    </el-tab-pane>
    <el-tab-pane label="成员订单">
      <el-form :inline="true" :model="searchQuery" size="small" style="text-align: left">
        <el-form-item label="时间区间">
          <el-date-picker v-model="timerange" @change="datechange" type="daterange" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="店铺ID">
          <el-input v-model="searchQuery.storeid"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="GetSubMemberOrderList">查询</el-button>
          <el-button type="warning" @click="exportData">导出</el-button>
          <el-button type="default" @click="reset">重置</el-button>

        </el-form-item>
      </el-form>
      <el-table :data="orderList" v-loading="loading">
        <el-table-column prop="companycontact" label="成员"></el-table-column>
        <el-table-column prop="CreateTime" label="创建时间"></el-table-column>
        <el-table-column prop="PassengerName" label="客人姓名"></el-table-column>
        <el-table-column prop="zh_name" label="国家"></el-table-column>
        <el-table-column prop="Passenger" label="人数"></el-table-column>
        <el-table-column prop="GetMoney" label="总价"></el-table-column>
        <el-table-column prop="returnedMoney" label="佣金"></el-table-column>
        <el-table-column prop="Status" label="签证状态">
          <template slot-scope="scope">
            <span>
              <!-- <el-link type="primary">{{GetStatus(scope.row.Status)}}</el-link> -->
              {{GetStatus(scope.row.Status)}}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" :total="count" :page-size="searchQuery.size"
        :current-page="searchQuery.index" @size-change="sizeChange" @current-change="handleCurrentChange">

      </el-pagination>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
  import moment from 'moment'
  export default {
    data() {
      return {
        memberList: [],
        orderList: [],
        searchQuery: {
          BeginTime: '',
          EndTime: '',
          storeid: '',
          index: 1,
          size: 10
        },
        timerange: [],
        count: 0,
        loading: false
      }
    },
    created() {
      this.getMemberList()
      this.GetSubMemberOrderList()
    },
    methods: {
      GetStatus(status) {

        var str = '';
        if (status == '0')
          str = '待确认'
        else if (status == '1')
          str = '待确认'
        else if (status == '501')
          str = '待审核'
        else if (status == '10')
          str = '需补资料'
        else if (status == '11')
          str = '拒签'
        else if (status == '7')
          str = '待出签'
        else if (status == '503')
          str = '待送签'
        else if (status == '5')
          str = '失败'
        else if (status == '8')
          str = '已完成'
        else if (status == '506')
          str = '上传签证页'
        else if (status == '507')
          str = "送回"
        return str;
      },
      handleCurrentChange(val) {
        this.searchQuery.index = val
        this.GetSubMemberOrderList()
      },
      sizeChange(val) {
        this.searchQuery.size = val
        this.GetSubMemberOrderList()
      },
      reset() {
        this.searchQuery = {
          BeginTime: '',
          EndTime: '',
          storeid: '',
          index: 1,
        }
        this.timerange = []
      },
      datechange() {
        if (!this.timerange) {
          this.searchQuery.BeginTime = ""
          this.searchQuery.EndTime = ""
        } else {
          this.searchQuery.BeginTime = moment(this.timerange[0]).format('YYYY-MM-DD') || ""
          this.searchQuery.EndTime = moment(this.timerange[1]).format('YYYY-MM-DD') || ""
          // this.GetSubMemberOrderList()
        }

      },
      getMemberList() {
        this.$api.GetSubMemberList().then(res => {
          console.log(res)
          if (res.data.status == 200) {
            this.memberList = res.data.data.data
          }
        })
      },
      GetSubMemberOrderList() {
        this.loading = true
        this.$api.GetSubMemberOrderList(this.searchQuery).then(res => {
          if (res.data.status == 200) {
            this.loading = false
            this.orderList = res.data.data.data,
              this.count = res.data.data.count
          }
        })
      },
      exportData() {
        this.$api.GetSubMemberOrderListExport(this.searchQuery).then(res => {
          if (res.data.status == 200) {
            debugger
            var a = document.createElement('a');
            a.href = res.data.data.Url;
            a.download = '会员订单.xlsx';
            a.target = '_blank';
            a.click();

          }
        })
      }
    }
  }

</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/page/personcenter/member.vue